// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 16px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f1f3;
  padding-bottom: 16px;
  margin-bottom: 24px;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #8a92a6;
  line-height: 1;
}

.modal-body .price-inputs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.price-input-group label {
  display: block;
  font-size: 14px;
  color: #3a445d;
  margin-bottom: 8px;
}

.price-input-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #d9dce1;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.price-input-group input:focus {
  outline: none;
  border-color: #ff8a00;
  box-shadow: 0 0 0 3px rgba(255, 138, 0, 0.2);
}

.modal-footer {
  margin-top: 24px;
  text-align: right;
}

.update-price-btn {
  background-color: #ff8a00;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}
.update-price-btn:hover {
  background-color: #e67b00;
}
.update-price-btn:disabled {
  background-color: #faddbb;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .modal-body .price-inputs-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .modal-header,
  .modal-footer {
    padding: 8px;
  }
  .modal-body .price-inputs-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/GeneratePriceModal/GeneratePriceModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,4DAA4D;AAC9D;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s;\n}\n\n.modal-content {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 600px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  animation: slideIn 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f0f1f3;\n  padding-bottom: 16px;\n  margin-bottom: 24px;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #8a92a6;\n  line-height: 1;\n}\n\n.modal-body .price-inputs-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.price-input-group label {\n  display: block;\n  font-size: 14px;\n  color: #3a445d;\n  margin-bottom: 8px;\n}\n\n.price-input-group input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #d9dce1;\n  border-radius: 8px;\n  font-size: 14px;\n  box-sizing: border-box;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.price-input-group input:focus {\n  outline: none;\n  border-color: #ff8a00;\n  box-shadow: 0 0 0 3px rgba(255, 138, 0, 0.2);\n}\n\n.modal-footer {\n  margin-top: 24px;\n  text-align: right;\n}\n\n.update-price-btn {\n  background-color: #ff8a00;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.update-price-btn:hover {\n  background-color: #e67b00;\n}\n.update-price-btn:disabled {\n  background-color: #faddbb;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .modal-body .price-inputs-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .modal-header,\n  .modal-footer {\n    padding: 8px;\n  }\n  .modal-body .price-inputs-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
